import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForceUpdateService {

  constructor() { }

  public subject : Subject<any> = new Subject();

  public resetDataInForm : Subject<any>  = new Subject();

  public editDataInForm : Subject<any>  = new Subject();

  getSubject(){
    return this.subject.asObservable();
  }

  getResetFormSubject(){
    return this.resetDataInForm.asObservable();
  }
  getEditFormSubject(){
    return this.editDataInForm.asObservable();
  }

  resetFormFromByParent( parent:string){
    this.resetDataInForm.next(parent);
  }

  editFormFromByParent( parent:string){
    this.editDataInForm.next(parent);
  }

  sendData( controlFilter? : string[], parent? : string) {
    if(controlFilter && controlFilter.length > 0) this.subject.next({array:controlFilter, parent : parent ? parent : null} );
    else this.subject.next(null);
  }
}
